module.exports = __webpack_public_path__ + "media/scholarship_winners/daniel-g-nj-02c5cd54.png";